import { ProjectUser } from '../models/project.model';

export enum TransferOwnershipOpenedFrom {
  transferOwnership = 'transfer_ownership',
  projectShare = 'project_share'
}

export interface IOpenTransferOwnershipConfirmationModal {
  openedFrom: TransferOwnershipOpenedFrom;
  user: ProjectUser;
}
